//  get host form state
export const getHost = (state) => (
  state.browser
    ? state.browser.getIn(['location', 'host']) // app4
    : state.getIn(['browser', 'location', 'host']) // app5
);

export default {};
